if (!customElements.get('srx-lens-builder')) {
  customElements.define('srx-lens-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      this.ui = JSON.parse(this.querySelector('[data-rx-copy]').textContent);
      this.dialog = this.querySelector('dialog');
      this.step = 0;
      this.lastStep = 7;
      this.sections = [0, 0, 1, 2, 2, 2, 3, 3];
      this.launch = this.querySelector('[data-rx-launch]');
      const on = (el, event, fn, capture = false) => el.addEventListener(event, fn, { signal: this.abort.signal, capture });
      on(this.launch, 'click', () => this.open());
      on(this.querySelector('[data-rx-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        clearTimeout(this.advanceTimer);
        document.body.style.overflow = this.previousOverflow ?? '';
        this.paint();
        const cartDialog = document.querySelector('cart-drawer.active [role=dialog]');
        (cartDialog || this.launch).focus();
      });
      on(this.dialog, 'click', e => { if (e.target === this.dialog && e.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close(); });
      on(this.querySelector('[data-rx-next]'), 'click', () => { if (this.validateStep(this.step)) this.go(this.nextStep(1)); });
      on(this.querySelector('[data-rx-back]'), 'click', () => this.go(this.nextStep(-1)));
      this.querySelectorAll('[data-rx-nav]').forEach(b => on(b, 'click', () => {
        const n = this.availableSteps().find(n => this.sections[n] === Number(b.dataset.rxNav));
        if (n !== undefined && n < this.step) this.go(n);
      }));
      on(this.querySelector('[data-rx-review]'), 'click', e => {
        const edit = e.target.closest('[data-rx-edit]');
        if (edit) this.go(Number(edit.dataset.rxEdit));
      });
      on(document, 'gpoRenderCompleted', () => this.syncForm());
      on(document, 'gpoElementChanged', () => this.refresh());
      on(document, 'gpoProductPriceUpdated', () => this.price());
      on(document, 'gpoValidated', e => {
        if (!this.form || !this.dialog.open || !this.submitting) return;
        if (e.detail?.success === false) {
          this.submitting = false;
          const field = this.form.querySelector('.gpo-input-error, .gpo-error input, [aria-invalid="true"]');
          const group = field?.closest('[data-rx-stage]');
          this.go(group ? Number(group.dataset.rxStage) : this.step, false);
          if (field?.focus) field.focus();
        } else this.paint();
      });
      on(document, 'gpoAddedToCart', () => {
        if (!this.submitting) return;
        this.submitting = false;
        window.location.assign(window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`);
      });
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        this.cartObserver = new MutationObserver(() => {
          if (this.dialog.open && !this.submitting && cartDrawer.classList.contains('active')) this.dialog.close();
        });
        this.cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
      this.renderObserver = new MutationObserver(() => {
        if (this.renderFrame) return;
        this.renderFrame = requestAnimationFrame(() => { this.renderFrame = null; this.syncForm(); this.price(); });
      });
      this.renderObserver.observe(this.closest('product-info') || this.parentElement, { childList: true, subtree: true });
      this.syncForm();
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.advanceTimer);
      this.renderObserver?.disconnect();
      this.cartObserver?.disconnect();
      if (this.renderFrame) cancelAnimationFrame(this.renderFrame);
      this.renderFrame = null;
      this.renderApp = null;
      if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow ?? ''; }
      this.bound = false;
    }
    syncForm() {
      const candidate = document.getElementById(this.dataset.formId);
      const app = candidate?.querySelector('.gpo-app');
      if (!app) return;
      const fields = app.querySelectorAll('input:not([type=hidden]),select,textarea');
      if (this.form === candidate && this.renderApp === app && this.renderFirst === fields[0] && this.renderCount === fields.length) return;
      this.attach(candidate);
      if (this.form === candidate) {
        this.renderApp = app;
        this.renderFirst = fields[0];
        this.renderCount = fields.length;
      }
    }
    attach(candidate) {
      if (!(candidate instanceof HTMLFormElement) || candidate.getAttribute('id') !== this.dataset.formId) return;
      const app = candidate.querySelector('.gpo-app');
      if (!app || !app.querySelector('input:not([type=hidden]),select,textarea')) return;
      if (!app.querySelector('[data-field-name="Vision Needs"]') || !app.querySelector('[data-field-name="Lens Package"]')) {
        this.querySelector('[data-rx-setup]')?.removeAttribute('hidden');
        return;
      }
      const host = candidate.closest('product-form') || candidate;
      if (this.form !== candidate) {
        if (this.form && this.originalHost?.isConnected) this.originalHost.remove();
        this.form = candidate;
        this.originalHost = host;
        this.querySelector('[data-rx-slot]').append(host);
        candidate.addEventListener('change', () => requestAnimationFrame(() => this.refresh()), { signal: this.abort.signal });
        candidate.addEventListener('click', e => this.queueAdvance(e), { signal: this.abort.signal });
        candidate.addEventListener('click', e => {
          if (!e.target.closest('button[type=submit],input[type=submit]')) return;
          for (let n = 0; n < this.lastStep; n++) {
            if (!this.validateStep(n)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
          }
          this.submitting = true;
          this.groups().forEach(g => g.classList.remove('srx-rx-offstage'));
        }, { capture: true, signal: this.abort.signal });
        candidate.addEventListener('keydown', e => {
          if (e.key === 'Enter' && e.target.matches('input:not([type=file])') && this.step < this.lastStep) {
            e.preventDefault(); if (this.validateStep(this.step)) this.go(this.nextStep(1));
          }
        }, { signal: this.abort.signal });
      }
      this.launch.hidden = false;
      this.querySelector('[data-rx-launch-note]').hidden = false;
      this.querySelector('[data-rx-setup]')?.setAttribute('hidden', '');
      this.classify();
      this.refresh();
      this.dispatchEvent(new CustomEvent('srx:prescription-ready', { bubbles: true }));
    }
    groups() { return [...(this.form?.querySelectorAll('.gpo-element') || [])]; }
    classify() {
      this.groups().forEach(g => {
        const field = g.querySelector('input:not([type=hidden]),select,textarea');
        const name = (field?.dataset.fieldName || field?.name || '').replace(/^properties\[|\]$/g, '').trim();
        const label = g.querySelector('.label-content')?.textContent.trim() || '';
        const key = `${name} ${label}`.toLowerCase();
        let stage = 2;
        if (/choose your lenses|vision needs|prescription type|correction|what do you use/.test(key)) stage = 0;
        else if (/progressive lens options/.test(key)) stage = 1;
        else if (/lens package|thickness|lens material/.test(key)) stage = 3;
        else if (/lens features/.test(key)) stage = 4;
        else if (/lens color|tint/.test(key)) stage = 5;
        else if (/coating/.test(key)) stage = 6;
        if (!field) g.classList.toggle('srx-rx-decoration', /^(divider|spacing)/.test(g.dataset.elementId || ''));
        g.dataset.rxField = name;
        g.dataset.rxStage = String(stage);
        if (stage === 3 && this.ui.lensPackages && !g.querySelector('.srx-rx-lens-note')) {
          const note = document.createElement('p'); note.className = 'srx-rx-lens-note';
          note.textContent = this.ui.lensPackages.illustrationNote + (this.dataset.rxProfile === 'oho' ? '' : ' ' + this.ui.lensPackages.similarNote);
          g.querySelector('.gpo-ov-wrapper')?.after(note);
        }
        g.classList.toggle('srx-rx-measure', !!field && /sph|cyl|axis|add-right|add-left|select-10|select-11|dual pd/.test(key));
        g.querySelectorAll('.gpo-ov-item > input').forEach(input => {
          const card = input.nextElementSibling;
          if (card?.tagName === 'LABEL') {
            card.dataset.rxKind = this.cardKind(input.value);
            if (stage === 1) card.dataset.rxProgressive = /advanced/i.test(input.value) ? 'advanced' : 'basic';
            if (stage === 3) this.packageCard(input, card);
            if (stage === 1 || stage === 3 || stage === 4 || stage === 6) this.inlineDescription(card, stage === 6);
            if (stage === 4 && card.dataset.rxKind !== 'screen') card.dataset.rxLensType = /transitions/i.test(input.value) ? 'transitions' : /photochromic/i.test(input.value) ? 'photochromic' : /polarized/i.test(input.value) ? 'polarized' : /sunglasses/i.test(input.value) ? 'tinted' : 'clear';
            if (stage === 5) this.colorCard(input, card, g);
            if (!card.querySelector('.srx-rx-card-symbol') && stage !== 5 && stage !== 3) {
              const icon = document.createElement('span');
              icon.className = 'srx-rx-card-symbol'; icon.setAttribute('aria-hidden', 'true');
              icon.append(stage === 1 ? this.progressiveIllustration(card.dataset.rxProgressive) : stage === 4 && card.dataset.rxKind !== 'screen' ? this.lensIllustration(card.dataset.rxLensType) : this.cardIcon(input.value)); card.prepend(icon);
            }
          }
          const caption = stage === 6 ? null : this.ui.descriptions[input.value.trim()];
          const labelEl = input.nextElementSibling;
          const nativeHelp = input.parentElement.querySelector('.gpo-ov-helptext');
          if (caption && nativeHelp?.textContent.trim() === caption) nativeHelp.hidden = true;
          if (!caption || labelEl?.tagName !== 'LABEL' || labelEl.querySelector('.srx-rx-chip-note')) return;
          const note = document.createElement('small'); note.className = 'srx-rx-chip-note'; note.textContent = caption; labelEl.append(note);
        });
      });
    }
    colorCard(input, card, group) {
      if (card.querySelector('.srx-rx-color-preview')) return;
      const images = {"Gray": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_1_1746636304631-1747414179.jpg", "Emerald": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_2_1746636168598-1747414184.jpg", "Brown": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_3_1746636675482-1747414188.jpg", "Sapphire": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_4_1746636691564-1747414192.jpg", "Amethyst": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_5_1746636704420-1747414196.jpg", "Graphite Green": "https://bluecutglasses.com/cdn/shop/files/image-swatches-1_6_1747413045150-1747414202.jpg"};
      const colors = {"Grey": "#353E3D", "Brown": "#402B16", "Green G15 Classic": "#263620", "Blue Velocity": "#1D3D63", "Ultraviolet Rush": "#4F2C5B", "Gray": "#353E3D", "Green": "#263620"};
      const value = input.value.trim();
      const transitions = /transitions/i.test(group.dataset.rxField);
      const preview = document.createElement('span');
      preview.className = 'srx-rx-color-preview'; preview.setAttribute('aria-hidden', 'true');
      if (transitions && images[value]) {
        const img = document.createElement('img');
        img.src = images[value]; img.alt = ''; img.width = 80; img.height = 80;
        img.decoding = 'async'; preview.append(img);
      } else {
        preview.classList.add('srx-rx-color-disc');
        preview.style.setProperty('--rx-lens-color', colors[value] || '#353e3d');
      }
      card.prepend(preview); card.dataset.rxColor = value;
    }
    packageCard(input, card) {
      const copy = this.ui.lensPackages;
      const index = input.value.match(/1\.(?:56|59|60|67|71|74|6(?!\d))/)?.[0];
      if (!copy || !index || card.dataset.rxPackage === index) return;
      const tiers = {'1.56': ['thin', 0, '1.56'], '1.60': ['thin', 0, '1.60'], '1.71': ['thinnest', 2, '1.71'], '1.6': ['thin', 0, '1.60'], '1.59': ['polycarbonate', 0, '1.59'], '1.67': ['thinner', 1, '1.67'], '1.74': ['thinnest', 2, '1.74']};
      const [key, tier, displayIndex] = tiers[index];
      const native = card.querySelector('.choicelist-item__value, .gpo-ov-title');
      if (!native) return;
      card.querySelector('.srx-rx-card-symbol')?.remove();
      card.dataset.rxPackage = index;
      // Keep Globo's radio value, native price node and help text intact.
      [...native.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).forEach(n => {
        const original = document.createElement('span'); original.className = 'srx-rx-package-original';
        original.setAttribute('aria-hidden', 'true'); n.replaceWith(original); original.append(n);
      });
      const title = document.createElement('strong'); title.className = 'srx-rx-package-title'; title.textContent = copy[key]; native.prepend(title);
      const visual = document.createElement('span'); visual.className = 'srx-rx-lens-visual';
      visual.append(this.lensProfiles(tier));
      const caption = document.createElement('span'); caption.className = 'srx-rx-lens-index'; caption.textContent = `${displayIndex} ${copy.index}`;
      visual.append(caption); card.prepend(visual);
      const description = document.createElement('small'); description.className = 'srx-rx-package-note'; description.textContent = copy[key + 'Note']; card.append(description);
    }
    inlineDescription(card, coating = false) {
      // Read the app-owned copy; keep its node and all price/input nodes untouched.
      const help = card.parentElement.querySelector('.gpo-ov-helptext');
      let text = help?.textContent.trim();
      if (coating && text) {
        text = text.replace(/^Optional\s+/i, '');
        text = text.charAt(0).toUpperCase() + text.slice(1);
        card.querySelector('.srx-rx-chip-note')?.remove();
      }
      let description = card.querySelector('.srx-rx-full-description');
      if (!text) { description?.remove(); return; }
      if (!description) {
        description = document.createElement('span');
        description.className = 'srx-rx-full-description';
        card.append(description);
      }
      if (description.textContent !== text) description.textContent = text;
      help.classList.add('srx-rx-description-source');
      card.classList.add('srx-rx-has-description');
    }
    progressiveIllustration(kind) {
      // Decorative diagrams: native choice labels, values and prices stay intact.
      const gradientId = `srx-progressive-${(this.dataset.formId || 'lens').replace(/[^a-zA-Z0-9_-]/g, '-')}-${kind}`;
      const corridor = kind === 'advanced'
        ? 'M12 56C28 55 32 66 32 78s-5 17-6 18M112 56C96 55 92 66 92 78s5 17 6 18'
        : 'M12 56C37 54 47 66 47 77s-9 19-10 25M112 56C87 54 77 66 77 77s9 19 10 25';
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 124 124');
      svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      svg.innerHTML = `<defs><linearGradient id="${gradientId}" x1="0%" y1="0%" x2="80%" y2="100%"><stop offset="0" stop-color="#fff"/><stop offset=".48" stop-color="#f0f4f6"/><stop offset="1" stop-color="#dae3e8"/></linearGradient></defs><ellipse cx="62" cy="67" rx="54" ry="51" fill="#dbe2e7" opacity=".45"/><path d="M62 8C29 8 9 23 9 52c0 34 21 59 53 59s53-25 53-59C115 23 95 8 62 8Z" fill="url(#${gradientId})" stroke="#b7c3cb" stroke-width="1.3"/><path d="M18 78c9 21 24 32 44 32s36-11 44-32" fill="none" stroke="#9aaab4" stroke-width="3" opacity=".6"/><path d="${corridor}" fill="none" stroke="#8c9ca6" stroke-width="1.5" stroke-dasharray="3.2 3.7" stroke-linecap="round"/><g fill="#475b68" font-family="Arial,sans-serif" text-anchor="middle" font-size="12"><text x="62" y="35">Distance</text><text x="62" y="64">Mid</text><text x="62" y="92">Near</text></g>`;
      return svg;
    }
    lensIllustration(kind) {
      // OHO sun lenses have one fixed gray tint; reuse the shared gray lens photo.
      if (this.dataset.rxProfile === 'oho' && kind === 'tinted') kind = 'polarized';
      const crops = {
        photochromic: [40, 150, 700, 350],
        transitions: [800, 150, 700, 350],
        clear: [55, 620, 420, 340],
        polarized: [555, 620, 420, 340],
        tinted: [1065, 620, 420, 340]
      };
      const [x, y, width, height] = crops[kind] || crops.clear;
      const photo = document.createElement('span');
      photo.className = 'srx-rx-lens-photo';
      photo.style.aspectRatio = `${width} / ${height}`;
      const img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/1032/5180/4441/files/smartrx-lens-photography-approved.png?v=1792431859&width=1200';
      img.alt = ''; img.width = 1536; img.height = 1024;
      img.loading = 'lazy'; img.decoding = 'async';
      img.style.width = `${1536 / width * 100}%`;
      img.style.left = `${-x / width * 100}%`;
      img.style.top = `${-y / height * 100}%`;
      photo.append(img);
      return photo;
    }
    lensProfiles(active) {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 120 72'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      [24, 16, 9].forEach((width, i) => {
        const x = 11 + i * 39;
        const group = document.createElementNS(ns, 'g');
        group.setAttribute('class', i === active ? 'srx-rx-profile-active' : 'srx-rx-profile-muted');
        const path = document.createElementNS(ns, 'path');
        path.setAttribute('d', `M${x} 6 C${x + width} 17 ${x + width} 49 ${x} 60 C${x + width * .28} 42 ${x + width * .28} 24 ${x} 6Z`);
        group.append(path);
        const highlight = document.createElementNS(ns, 'path');
        highlight.setAttribute('d', `M${x + 2} 10 C${x + width * .72} 21 ${x + width * .72} 45 ${x + 2} 56`);
        highlight.setAttribute('class', 'srx-rx-profile-shine');group.append(highlight);
        if (i === active) {
          const marker = document.createElementNS(ns, 'rect');
          marker.setAttribute('x', String(x - 2));marker.setAttribute('y', '66');marker.setAttribute('width', String(width + 4));marker.setAttribute('height', '3');marker.setAttribute('rx', '1.5');group.append(marker);
        }
        svg.append(group);
      });
      return svg;
    }
    cardKind(value) {
      if (/^1\./.test(value)) return 'package';
      if (/polarized|sunglasses/i.test(value)) return 'sun';
      if (/photochromic|transitions/i.test(value)) return 'adaptive';
      if (/upload/i.test(value)) return 'upload';
      if (/manually/i.test(value)) return 'manual';
      if (/later/i.test(value)) return 'later';
      if (/hydrophobic/i.test(value)) return 'water';
      if (/reflective/i.test(value)) return 'reflection';
      if (/blue light/i.test(value)) return 'screen';
      if (/distance/i.test(value)) return 'distance';
      if (/reading/i.test(value)) return 'reading';
      if (/progressive/i.test(value)) return 'progressive';
      return 'clear';
    }
    cardIcon(value) {
      const kind = this.cardKind(value);
      const paths = {
        package: ['M5 9c0-3 22-3 22 0s-22 3-22 0Z', 'M5 9v6c0 3 22 3 22 0V9', 'M5 15v6c0 3 22 3 22 0v-6'],
        sun: ['M10 9V5m-6 8H1m4-7L3 4m15 2 2-2', 'M6 13a5 5 0 0 1 10 0', 'M3 19h10v5a4 4 0 0 1-8 0l-2-5Zm16 0h10l-2 5a4 4 0 0 1-8 0v-5Zm-6 1h6'],
        adaptive: ['M16 5a11 11 0 1 0 0 22V5Z', 'M20 6a11 11 0 0 1 0 20', 'M23 10h3m-3 6h4m-4 6h3'],
        upload: ['M8 3h11l6 6v20H8V3Z', 'M19 3v7h6', 'M16 24V13m-4 4 4-4 4 4'],
        manual: ['M19 3H6v26h17V17', 'M10 9h5m-5 5h4m-4 10 5-1L28 10l-4-4-13 13-1 5Z', 'm21 9 4 4'],
        later: ['M5 7h22a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z', 'm4 9 12 9L28 9', 'm4 23 8-8m16 8-8-8'],
        water: ['M16 3S7 14 7 20a9 9 0 0 0 18 0C25 14 16 3 16 3Z', 'M11 20a5 5 0 0 0 5 5'],
        reflection: ['M16 3v6', 'M11 9h10l6 12H5l6-12Z', 'M12 21a4 4 0 0 0 8 0', 'M16 28v2m-7-5-2 3m16-3 2 3'],
        screen: ['M3 5h26v18H3V5Z', 'M10 28h12m-6-5v5', 'm18 9-6 10m11-10-6 10'],
        reading: ['M16 7C12 4 7 4 3 5v22c4-1 9-1 13 2 4-3 9-3 13-2V5c-4-1-9-1-13 2v22', 'M7 11h5m-5 5h5m8-5h5m-5 5h5'],
        progressive: ['m2 20 8-13 7 10 4-6 9 14H2l0-5Z', 'm7 12 3 3 3-3', 'M14 21c3-1 5-1 8 1 3-2 5-2 8-1v9c-3-1-5-1-8 1-3-2-5-2-8-1v-9Zm8 1v9'],
        distance: ['M2 27 13 8l8 14 4-6 6 11H2Z', 'm9 15 4 3 4-3', 'M24 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z'],
        clear: ['M3 20a5 5 0 1 0 10 0 5 5 0 0 0-10 0Zm16 0a5 5 0 1 0 10 0 5 5 0 0 0-10 0Z', 'M13 20h6M3 19V9l3-3m23 13V9l-3-3']
      };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 32 32'); svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.3');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('focusable', 'false');
      paths[kind].forEach(d => { const path = document.createElementNS(svg.namespaceURI, 'path'); path.setAttribute('d', d); svg.append(path); });
      return svg;
    }
    active(g) {
      const fields = [...g.querySelectorAll('input:not([type=hidden]),select,textarea')];
      if (fields.length) return fields.some(f => !f.disabled);
      return !g.hidden && g.style.display !== 'none' && !g.classList.contains('gpo-hidden');
    }
    availableSteps() { return [0, 1, 2, 3, 4, 5, 6].filter(n => this.groups().some(g => Number(g.dataset.rxStage) === n && !g.classList.contains('srx-rx-fixed-color') && this.active(g) && g.querySelector('input:not([type=hidden]),select,textarea'))).concat(this.lastStep); }
    syncFixedColor() {
      const feature = this.form.querySelector('[data-field-name="Lens Features"]:checked')?.value || '';
      const standardPhotochromic = /photochromic/i.test(feature) && !/transitions/i.test(feature);
      this.groups().filter(g => /photochromic.*color/i.test(g.dataset.rxField)).forEach(g => {
        g.classList.toggle('srx-rx-fixed-color', standardPhotochromic);
        if (!standardPhotochromic) return;
        const gray = [...g.querySelectorAll('input[type=radio]')].find(f => /^gr[ae]y$/i.test(f.value.trim()));
        if (gray && !gray.disabled && !gray.checked) gray.click();
      });
    }
    nextStep(direction) {
      const steps = this.availableSteps();
      return direction > 0 ? (steps.find(n => n > this.step) ?? this.lastStep) : ([...steps].reverse().find(n => n < this.step) ?? 0);
    }
    queueAdvance(event) {
      const input = event.target.closest('input[type=radio]');
      const stage = this.step;
      if (!event.isTrusted || event.detail === 0 || !input || !this.dialog.open || ![0, 1, 3, 4, 5].includes(stage)) return;
      const group = input.closest('[data-rx-stage]');
      if (!group || Number(group.dataset.rxStage) !== stage || input.disabled) return;
      if (stage === 0 && group.dataset.rxField === 'Choose Your Lenses' && input.value !== 'No Prescription') return;
      clearTimeout(this.advanceTimer);
      this.advanceTimer = setTimeout(() => {
        if (!this.isConnected || !this.dialog.open || this.step !== stage || !input.isConnected || input.disabled || !input.checked) return;
        this.refresh();
        if (this.step === stage && this.validateStep(stage)) this.go(this.nextStep(1));
      }, 220);
    }
    open() {
      if (!this.form) return;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal(); this.go(this.step);
    }
    go(n, focus = true) {
      clearTimeout(this.advanceTimer);
      this.step = n;
      this.querySelector('[data-rx-error]').hidden = true;
      this.paint(); this.review(); this.price();
      const body = this.querySelector('.srx-rx-body'); body.scrollTop = 0;
      if (focus) this.querySelector('[data-rx-title]').focus({ preventScroll: true });
    }
    paint() {
      this.dialog.dataset.step = String(this.step);
      this.dialog.toggleAttribute('data-review', this.step === this.lastStep);
      this.groups().forEach(g => g.classList.toggle('srx-rx-offstage', Number(g.dataset.rxStage) !== this.step));
      this.querySelector('[data-rx-title]').textContent = this.ui.titles[this.step];
      this.querySelector('[data-rx-intro]').textContent = this.ui.intros[this.step];
      const steps = this.availableSteps();
      this.querySelector('[data-rx-eyebrow]').textContent = `${this.ui.step} ${this.sections[this.step] + 1} / 4`;
      this.querySelector('[data-rx-context]').textContent = this.ui.contexts[this.step];
      this.querySelector('[data-rx-review]').hidden = this.step !== this.lastStep;
      this.querySelector('[data-rx-review-note]').hidden = this.step !== this.lastStep;
      this.querySelector('[data-rx-back]').hidden = this.step === this.availableSteps()[0];
      this.querySelector('[data-rx-next]').hidden = this.step === this.lastStep;
      this.querySelectorAll('[data-rx-nav]').forEach(b => {
        const n = Number(b.dataset.rxNav); b.disabled = n >= this.sections[this.step] || !steps.some(step => this.sections[step] === n);
        if (n === this.sections[this.step]) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        b.toggleAttribute('data-complete', n < this.sections[this.step]);
      });
    }
    validateStep(n) {
      for (const g of this.groups().filter(g => Number(g.dataset.rxStage) === n && this.active(g))) {
        const fields = [...g.querySelectorAll('input:not([type=hidden]),select,textarea')].filter(f => !f.disabled);
        if (!fields.length) continue;
        const required = fields.some(f => f.required || f.hasAttribute('presence')) || !!g.querySelector('.gpo-label.required');
        if (!required) continue;
        const choice = fields.every(f => ['radio', 'checkbox'].includes(f.type));
        const valid = choice ? fields.some(f => f.checked) : fields.every(f => f.type === 'file' ? this.fileNames(f).length > 0 : f.value.trim() !== '');
        if (valid) continue;
        this.go(n, false);
        const error = this.querySelector('[data-rx-error]'); error.textContent = this.ui.required; error.hidden = false;
        fields[0].focus(); g.scrollIntoView({ block: 'center', behavior: 'smooth' }); return false;
      }
      return true;
    }
    fileNames(field) {
      if (field.matches('.gpo-file[data-type="file"]')) {
        if (field.dataset.hasFile !== 'true') return [];
        return [...field.closest('.gpo-element').querySelectorAll('.gpo-f-card .gpo-f-name')]
          .map(name => name.textContent.trim()).filter(Boolean);
      }
      return [...(field.files || [])].map(file => file.name);
    }
    refresh() {
      if (!this.form) return;
      this.classify();
      this.syncFixedColor();
      if (!this.availableSteps().includes(this.step)) this.step = this.nextStep(-1);
      this.paint(); this.review(); this.price();
    }
    price() {
      if (this.dataset.rxProfile === 'oho') {
        const data = this.querySelector('[data-rx-addon-prices]');
        if (!data) return;
        const pricing = JSON.parse(data.textContent);
        const selected = [...(this.form?.querySelectorAll('[data-field-name="Lens Package"]:checked:not(:disabled),[data-field-name="Lens Features"]:checked:not(:disabled)') || [])];
        const amounts = selected.map(field => pricing.variants[field.getAttribute('gpo-data-variant-id')]);
        const addon = amounts.reduce((sum, amount) => sum + Number(amount || 0), 0);
        const total = this.querySelector('[data-rx-price]');
        if (amounts.some(amount => amount === undefined)) { total.textContent = '—'; return; }
        const value = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: pricing.currency }).format((Number(this.dataset.frameCents || 0) + Number(addon)) / 100);
        if (total.textContent !== value) total.textContent = value;
        return;
      }
      const scope = this.closest('product-info') || document;
      const price = scope.querySelector('[data-gpo-product-unit-price],.price:not(.price--on-sale) .price-item--regular,.price--on-sale .price-item--sale');
      const total = this.querySelector('[data-rx-price]');
      const value = price?.textContent.trim();
      if (value && total.textContent !== value) total.textContent = value;
    }
    review() {
      const target = this.querySelector('[data-rx-review]'); target.replaceChildren();
      this.groups().filter(g => this.active(g)).forEach(g => {
        const fields = [...g.querySelectorAll('input:not([type=hidden]),select,textarea')].filter(f => !f.disabled);
        if (!fields.length) return;
        const values = fields.flatMap(f => {
          if (['radio', 'checkbox'].includes(f.type)) return f.checked ? [f.value.trim()] : [];
          if (f.type === 'file') return this.fileNames(f);
          return f.value ? [f.value.trim()] : [];
        });
        if (!values.length) return;
        const row = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = (fields[0].dataset.fieldName || fields[0].name || g.querySelector('.label-content')?.textContent || '').replace(/^properties\[|\]$/g, '');
        dd.textContent = values.join(', ');
        const edit = document.createElement('button'); edit.type = 'button';
        edit.className = 'srx-rx-edit'; edit.dataset.rxEdit = g.classList.contains('srx-rx-fixed-color') ? '4' : g.dataset.rxStage;
        edit.textContent = this.ui.edit; edit.setAttribute('aria-label', `${this.ui.edit}: ${dt.textContent}`);
        row.append(dt, dd, edit); target.append(row);
      });
    }
  });
}



